/* eslint-disable camelcase */
import { AxiosResponse } from 'axios'
import client from './client'

const signinCustomer =
  ({
    message,
    signature,
    wallet,
    message_sign,
    sponsor_address = '0x8b9588F69e04D69655e0d866cD701844177360A7',
  }: {
    message: string
    signature: string
    wallet: string
    message_sign: string
    sponsor_address?: string
  }) =>
  async () => {
    const response = await client.request<AxiosResponse>({
      method: 'POST',
      url: `/customers/signin`,
      data: {
        message,
        signature,
        wallet,
        message_sign,
        // sponsor_address,
      },
    })

    return response.data.data
  }
export default { signinCustomer }
